module.exports = __webpack_public_path__ + "img/seven_brown.b2934be3.svg";